'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'tree';
var width = 448;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M75.8 400L200 400l0-184 0-24 48 0 0 24 0 184 124.2 0-41.1-49.3L304 318.2l0-46.2 36.1 0-30.1-30.1L272 203.9l0-43.9 38.4 0L224 69.5 137.6 160l38.4 0 0 43.9-38.1 38.1L107.9 272l36.1 0 0 46.2-27.1 32.6L75.8 400z', 'M392 188.1l0-12.1-15.3-16L257.2 34.8 224 0 190.8 34.8 71.3 160 56 176l0 12.1L56 208l33.5 0 2.3 0 12.2 0L56 256 40 272 24 288l0 24.2 0 7.8 32 0 3.9 0L72 320l8 0L40 368 13.3 400 0 416l0 32 48 0 152 0 0 40 0 24 48 0 0-24 0-40 152 0 48 0 0-32-13.3-16L408 368l-40-48 8 0 12.1 0 3.9 0 32 0 0-7.8 0-24.2-16-16-16-16-48-48 12.2 0 2.3 0 33.5 0 0-19.9zM248 400l0-184 0-24-48 0 0 24 0 184L75.8 400l41.1-49.3L144 318.2l0-46.2-36.1 0 30.1-30.1L176 203.9l0-43.9-38.4 0L224 69.5 310.4 160 272 160l0 43.9 38.1 38.1L340.1 272 304 272l0 46.2 27.1 32.6L372.2 400 248 400z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;